import { render, staticRenderFns } from "./SidebarFix.vue?vue&type=template&id=3aacc337&"
import script from "./SidebarFix.vue?vue&type=script&lang=js&"
export * from "./SidebarFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports